import React, { ImgHTMLAttributes } from 'react';

type Props = ImgHTMLAttributes<SVGElement>;

const Loading2: React.FC<Props> = ({ className }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
    <mask
      id='mask0_3608_12797'
      style={{ maskType: 'alpha' }}
      maskUnits='userSpaceOnUse'
      x='0'
      y='0'
      width='24'
      height='24'
    >
      <circle cx='12' cy='12' r='12' fill='currentColor' />
    </mask>
    <g mask='url(#mask0_3608_12797)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11 1C11 0.447715 11.4477 0 12 0C18.6274 0 24 5.37258 24 12C24 12.5523 23.5523 13 23 13C22.4477 13 22 12.5523 22 12C22 6.47715 17.5228 2 12 2C11.4477 2 11 1.55228 11 1Z'
        fill='currentColor'
      />
    </g>
  </svg>
);

export { Loading2 };
